export function IpGuideChromeOs() {
  return (
    <div className="space-y-6">
      {/* Step 1 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          1
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Unten rechts auf den <strong>Systembereich</strong> (Uhrzeit/WLAN-Icon) klicken.
          </p>
          <svg viewBox="0 0 300 90" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-sm mx-auto block rounded-lg" aria-hidden="true">
            {/* ChromeOS desktop */}
            <defs>
              <linearGradient id="crosDesk" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#1a237e" />
                <stop offset="100%" stopColor="#3949ab" />
              </linearGradient>
            </defs>
            <rect width="300" height="90" fill="url(#crosDesk)" />
            {/* Shelf */}
            <rect x="0" y="66" width="300" height="24" fill="#1a1a2e" />
            {/* App icons */}
            <circle cx="20" cy="78" r="8" fill="#4285f4" />
            <text x="20" y="82" textAnchor="middle" fontSize="9" fill="#fff">G</text>
            <circle cx="42" cy="78" r="8" fill="#34a853" />
            <text x="42" y="82" textAnchor="middle" fontSize="9" fill="#fff">✉</text>
            {/* System tray – highlighted */}
            <rect x="216" y="68" width="80" height="20" rx="5" fill="rgba(255,255,255,0.18)" stroke="rgba(255,255,255,0.45)" strokeWidth="1.2" />
            <text x="222" y="81" fontSize="10" fill="#fff">◈</text>
            <text x="237" y="81" fontSize="9" fill="#fff">🔊</text>
            <text x="252" y="81" fontSize="8.5" fill="#fff">100%</text>
            <text x="272" y="81" textAnchor="middle" fontSize="7.5" fill="#fff">9:41</text>
            {/* Arrow */}
            <polygon points="256,66 250,54 262,54" fill="#ff9500" />
            <rect x="226" y="40" width="60" height="13" rx="3" fill="rgba(0,0,0,0.6)" />
            <text x="256" y="50" textAnchor="middle" fontSize="8.5" fill="#fff">hier klicken</text>
          </svg>
        </div>
      </div>

      {/* Step 2 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          2
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Im Schnellmenü auf den <strong>Pfeil ›</strong> neben dem WLAN-Namen klicken.
          </p>
          <svg viewBox="0 0 240 230" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-[225px] mx-auto block rounded-lg" aria-hidden="true">
            <rect x="4" y="4" width="232" height="222" rx="14" fill="#2a2a2a" stroke="#444" strokeWidth="0.8" filter="drop-shadow(0 4px 16px rgba(0,0,0,0.4))" />
            <text x="120" y="32" textAnchor="middle" fontSize="12" fontWeight="500" fill="#e8eaed">Schnelleinstellungen</text>
            <line x1="12" y1="40" x2="228" y2="40" stroke="#444" strokeWidth="0.5" />
            {/* WiFi toggle */}
            <rect x="12" y="46" width="216" height="50" rx="8" fill="#3d3d3d" />
            <rect x="22" y="60" width="3" height="6" rx="1.5" fill="#8ab4f8" />
            <rect x="27" y="56" width="3" height="10" rx="1.5" fill="#8ab4f8" />
            <rect x="32" y="51" width="3" height="15" rx="1.5" fill="#8ab4f8" />
            <text x="44" y="65" fontSize="12" fill="#e8eaed" fontWeight="500">ALB-WLAN</text>
            <text x="44" y="80" fontSize="10" fill="#9aa0a6">Verbunden · Internet</text>
            {/* Arrow button – highlighted */}
            <rect x="186" y="57" width="32" height="26" rx="6" fill="rgba(138,180,248,0.25)" stroke="#8ab4f8" strokeWidth="1.5" />
            <text x="202" y="74" textAnchor="middle" fontSize="16" fill="#8ab4f8">›</text>
            <line x1="12" y1="100" x2="228" y2="100" stroke="#444" strokeWidth="0.5" />
            {/* Brightness & Volume row */}
            <rect x="12" y="106" width="102" height="48" rx="8" fill="#3d3d3d" />
            <text x="63" y="135" textAnchor="middle" fontSize="22" fill="#9aa0a6">☀</text>
            <rect x="122" y="106" width="106" height="48" rx="8" fill="#3d3d3d" />
            <text x="175" y="135" textAnchor="middle" fontSize="22" fill="#9aa0a6">🔊</text>
            <line x1="12" y1="162" x2="228" y2="162" stroke="#444" strokeWidth="0.5" />
            {/* Settings row */}
            <text x="120" y="192" textAnchor="middle" fontSize="11" fill="#8ab4f8">⚙ Einstellungen</text>
          </svg>
        </div>
      </div>

      {/* Step 3 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          3
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            In den Netzwerkdetails steht die <strong>IP-Adresse</strong>.
          </p>
          <svg viewBox="0 0 300 210" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-sm mx-auto block rounded-lg" aria-hidden="true">
            {/* Window frame – ChromeOS style (controls RIGHT) */}
            <rect width="300" height="210" rx="10" fill="#202124" stroke="#3c3c3c" strokeWidth="0.8" />
            {/* Title bar */}
            <rect width="300" height="32" rx="10" fill="#2d2d2d" />
            <rect x="0" y="16" width="300" height="16" fill="#2d2d2d" />
            <text x="18" y="20" textAnchor="start" fontSize="11" fill="#e8eaed">ALB-WLAN Details</text>
            {/* ChromeOS controls – RIGHT side (not left!) */}
            {/* Minimize */}
            <rect x="242" y="8" width="16" height="16" rx="8" fill="rgba(255,255,255,0.1)" />
            <text x="250" y="20" textAnchor="middle" fontSize="9" fill="#9aa0a6">─</text>
            {/* Maximize */}
            <rect x="262" y="8" width="16" height="16" rx="8" fill="rgba(255,255,255,0.1)" />
            <rect x="267" y="13" width="6" height="6" rx="1" fill="none" stroke="#9aa0a6" strokeWidth="1.2" />
            {/* Close */}
            <rect x="282" y="8" width="16" height="16" rx="8" fill="rgba(255,255,255,0.1)" />
            <text x="290" y="20" textAnchor="middle" fontSize="11" fill="#9aa0a6">×</text>
            {/* Content */}
            <text x="18" y="54" fontSize="10.5" fill="#9aa0a6">Netzwerkname</text>
            <text x="18" y="68" fontSize="13" fill="#e8eaed">ALB-WLAN</text>
            <line x1="12" y1="76" x2="288" y2="76" stroke="#3c3c3c" strokeWidth="0.5" />
            <text x="18" y="92" fontSize="10.5" fill="#9aa0a6">Verbindungstyp</text>
            <text x="18" y="106" fontSize="13" fill="#e8eaed">WLAN (2.4 GHz)</text>
            <line x1="12" y1="114" x2="288" y2="114" stroke="#3c3c3c" strokeWidth="0.5" />
            {/* IP row – red border */}
            <rect x="10" y="116" width="280" height="36" rx="5" fill="rgba(239,68,68,0.12)" />
            <rect x="10" y="116" width="280" height="36" rx="5" fill="none" stroke="#ef4444" strokeWidth="1.8" />
            <text x="18" y="130" fontSize="10.5" fill="#8ab4f8">IP-Adresse</text>
            <text x="18" y="146" fontSize="14" fontWeight="700" fill="#e8eaed">192.168.1.42</text>
            <polygon points="290,134 298,129 298,139" fill="#ef4444" />
            <line x1="12" y1="154" x2="288" y2="154" stroke="#3c3c3c" strokeWidth="0.5" />
            <text x="18" y="170" fontSize="10.5" fill="#9aa0a6">Subnetzmaske</text>
            <text x="18" y="184" fontSize="13" fill="#9aa0a6">255.255.255.0</text>
            <line x1="12" y1="192" x2="288" y2="192" stroke="#3c3c3c" strokeWidth="0.5" />
          </svg>
        </div>
      </div>
    </div>
  );
}
